/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Options/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Radial from 'DesignSystem/Radial/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Options({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsCreatePaymentPlanForExistingInvoice/Content/Content/PaymentSources/Options"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let paymentSourceIdValueData = fromData.useDataValue({ viewPath,
context: 'payment_source',
path: 'id',
})
let newPaymentPlanSelectedPaymentSourceValueData = fromData.useDataValue({ viewPath,
context: 'new_payment_plan',
path: 'selected_payment_source',
})
let aggregateData = fromAggregate.equals(paymentSourceIdValueData, newPaymentPlanSelectedPaymentSourceValueData)
let onClick1 = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let paymentSourceTextValueData = fromData.useDataValue({ viewPath,
context: 'payment_source',
path: 'text',
})
let paymentSourceDescriptionValueData = fromData.useDataValue({ viewPath,
context: 'payment_source',
path: 'description',
})
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
  return (<React.Fragment
>
<button
  data-testid="Options.Horizontal"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--mt-1-tY85I': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Options.Horizontal:1"
  data-view-path={viewPath}
 style={{'--mr-2-tY85I': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal1}`}
>
<Radial
  viewPath={`${viewPath}/Radial`}
 data="payment_source.id"
 data="new_payment_plan.selected_payment_source"
 aggregate="/Data/aggregate.js equals"
 isSelected={aggregateData}
 onClick={onClick1}
 paddingRight={0}
/>
<div
  data-testid="Options.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 data="payment_source.text"
 text={paymentSourceTextValueData}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral600}
 data="payment_source.description"
 text={paymentSourceDescriptionValueData}
/>
</div>
</div>
</button>
{children}
</React.Fragment>)
}